import React, { useContext, useEffect, useState } from 'react'

import { useSellerIsBlocked } from '@/proxy/seller/hooks'
import POC_ALL_STATUS from '@/resources/enums/pocAllPossibleStatus'
import { REQUEST_ERRORS_CODES } from '@/resources/enums/errors/requestErrors'
import { isAuthenticated } from '@/resources/services/permission/auth'
import { SELLER_DATA } from '@/resources/utils'

export const SellerContext = React.createContext()

export const SellerProvider = props => {
  const [responseSellerData, setResponseSellerData] = useState(null)

  const {
    ONBOARDING,
    ASSISTED_OPERATIONAL,
    OPERATIONAL,
    REJECTED,
    NOT_VALIDATED,
    REGISTERED,
  } = POC_ALL_STATUS

  const {
    isLoading: isLoadingSeller = false,
    isFetched: isFetchedSeller = false,
    data: sellerData = null,
    refetch,
  } = useSellerIsBlocked()

  const role = sellerData?.user?.role ?? ''

  const isCircuitOpen =
    sellerData?.error?.code === REQUEST_ERRORS_CODES.CIRCUIT_IS_OPEN

  useEffect(() => {
    if (isLoadingSeller) return

    if (!isCircuitOpen) {
      setResponseSellerData(sellerData)
      localStorage.setItem(SELLER_DATA, JSON.stringify(sellerData))

      return
    }

    setResponseSellerData(JSON.parse(localStorage.getItem(SELLER_DATA)))
  }, [isCircuitOpen, isLoadingSeller, sellerData])

  const isOperating =
    responseSellerData?.seller?.status === ASSISTED_OPERATIONAL ||
    responseSellerData?.seller?.status === OPERATIONAL

  const isTrainingOrOperating =
    responseSellerData?.seller?.status === ONBOARDING ||
    responseSellerData?.seller?.status === ASSISTED_OPERATIONAL ||
    responseSellerData?.seller?.status === OPERATIONAL

  const isRejectedOrIvalidated =
    responseSellerData?.seller?.status === REJECTED ||
    responseSellerData?.seller?.status === NOT_VALIDATED

  const isRegistered = responseSellerData?.seller?.status === REGISTERED

  const isRegisteredWithoutMainPhoneNumber =
    responseSellerData?.seller?.status === REGISTERED &&
    responseSellerData?.seller?.mainPhoneNumber === null

  const hasTwinSeller = !!responseSellerData?.seller?.twinSellerId
  const deliveryMethods =
    responseSellerData?.seller?.shop?.deliveryMethods?.map(
      ({ type }) => type
    ) || []

  const isPocCBE = responseSellerData?.seller?.category === 'CBE'

  const value = {
    isLoadingSeller,
    isFetchedSeller,
    sellerData: responseSellerData,
    isOperating,
    isPocCBE,
    isTrainingOrOperating,
    isRejectedOrIvalidated,
    isRegistered,
    isRegisteredWithoutMainPhoneNumber,
    isCircuitOpen,
    hasTwinSeller,
    deliveryMethods,
    role,
    refetch,
  }

  return <SellerContext.Provider value={value} {...props} />
}

export const useSeller = () => {
  const context = useContext(SellerContext)
  if (isAuthenticated() && context === undefined) {
    throw new Error('useSeller must be used within a SellerContext')
  }
  return context
}
